import script from "./RightContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./RightContainer.vue?vue&type=script&setup=true&lang=ts"

import "./RightContainer.vue?vue&type=style&index=0&id=37c45c50&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37c45c50"]])

export default __exports__